import { type ComponentRef, Directive, input, output, type Type } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { FormFolderSummaryDto } from '@sharedlib/dtos/dto/forms-app/form.dto';
import { takeUntil } from 'rxjs';
import { FormFolderContextMenuComponent } from './form-folder-context-menu.component';
/** Mechanical Forms adaptation of BoardsFolderContextMenuDirective. */
@Directive({ selector: '[appFormFolderContextMenu]', standalone: true })
export class FormFolderContextMenuDirective extends ContextMenuDirective {
  public readonly appFormFolderContextMenu = input.required<FormFolderSummaryDto>();
  public readonly appFormFolderContextMenuMode = input<'contextmenu' | 'popover'>('contextmenu');
  public override ngOnInit(): void {
    super.ngOnInit();
    if (this.appFormFolderContextMenuMode() === 'popover') { this.stchPopoverTrigger = 'click'; this.stchPopoverPlacement = 'bottomRight'; this.stchPopoverFallbackPlacements = ['bottomLeft']; }
  }
  public readonly appFormFolderContextMenuOpen = output<boolean>();
  protected registerComponent(): Type<FormFolderContextMenuComponent> { return FormFolderContextMenuComponent; }
  protected registerInstance(ref: ComponentRef<FormFolderContextMenuComponent>): void {
    ref.setInput('item', this.appFormFolderContextMenu());
    outputToObservable(ref.instance.open).pipe(takeUntil(this.alive)).subscribe(all => this.appFormFolderContextMenuOpen.emit(all));
  }
}
